import { ContactResource, ContactTypes } from "../../js/classes/Api/Contact";
import { reactive } from "vue";
const state = reactive({
    isLoading: false,
    contacts: undefined
});
export default function useFinanceProviderStore() {
    async function getFinanceProviders() {
        if (!state.isLoading && state.contacts === undefined) {
            state.isLoading = true;
            await ContactResource.all({ type: ContactTypes.FINANCE_PROVIDER, limit: 200 }).then((response) => {
                state.contacts = response.data.results;
            }).finally(() => {
                state.isLoading = false;
            });
        }
        return state.contacts;
    }
    getFinanceProviders();
    return {
        state,
        getFinanceProviders
    };
}
